module.exports = __webpack_public_path__ + "static/media/omg_wow_video.b2254bc7.ogg";